export const SIDEBAR_WIDTH = 'w-[240px]';
export const SIDEBAR_CLASSES = 'w-[240px] h-full border-r shrink-0 hidden lg:flex flex-col bg-muted/30';
export const SIDEBAR_HEADER_CLASSES = 'h-12 flex items-center justify-between px-3 border-b';
export const SIDEBAR_TITLE_CLASSES = 'font-semibold text-sm';
export const SIDEBAR_NAV_CONTAINER_CLASSES = 'py-2';
export const SIDEBAR_NAV_ITEM_CLASSES = 'w-full flex items-center gap-2 px-3 py-2 text-sm transition-colors hover:bg-muted';
export const SIDEBAR_NAV_ITEM_ACTIVE_CLASSES = 'bg-muted font-medium';
export const SIDEBAR_NAV_ITEM_INACTIVE_CLASSES = 'text-muted-foreground hover:text-foreground';
